import { useExpensesData } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/hooks/useExpensesData'

import { Base } from './Base'
import { CustomChildrenProps } from './props'

export const Expenses = ({
  id,
  level,
  groupBy,
  headerLength,
  tableHeadRef,
  parentHasItemWithChildren,
  setParentHasItemWithChildren,
}: CustomChildrenProps) => {
  return (
    <Base
      id={id}
      level={level}
      type="expenses"
      groupBy={groupBy}
      hook={useExpensesData}
      headerLength={headerLength}
      tableHeadRef={tableHeadRef}
      parentHasItemWithChildren={parentHasItemWithChildren}
      setParentHasItemWithChildren={setParentHasItemWithChildren}
    />
  )
}
